import { lazy } from "react";
import Loadable from "components/Loadable.tsx";

const NotificationPushLogList = Loadable(
  lazy(() => import("features/notification/logsPush/components/List"))
);

const routes = {
  path: "push",
  children: [{ path: "", element: <NotificationPushLogList /> }],
};

export default routes;
